import React from 'react'
import OneDrivePage from '../../../../../components/Onedrive/OneDrive'

const ActualsOneDrive = () => {
  return <OneDrivePage type="actuals" dokumentationPath="/integrations/manual/onedrive-accounting" />
}

export default ActualsOneDrive
